import { render } from "./Team_manager_en_m.vue?vue&type=template&id=0205d916&scoped=true"
import script from "./Team_manager_en_m.vue?vue&type=script&lang=js"
export * from "./Team_manager_en_m.vue?vue&type=script&lang=js"

import "./Team_manager_en_m.vue?vue&type=style&index=0&id=0205d916&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0205d916"

export default script